// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons';
// Service imports:
import { turnDateToSimpleTime } from '../../services/utils';
// Action imports:
import { setCurrentTradingDay } from '../../redux-store/actions/dashboardActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps;

interface IState {
    isDatePickerFocused: boolean
}

class DatePicker extends React.Component<Props, IState> {
    pickerRef: React.RefObject<HTMLDivElement>;
    constructor(props: Props) {
        super(props);
        this.state = {
            isDatePickerFocused: false
        }
        this.pickerRef = React.createRef() as React.RefObject<HTMLDivElement>;
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event: MouseEvent) => {
        if (this.state.isDatePickerFocused && this.pickerRef.current && !this.pickerRef.current.contains(event.target as Node)) {
            this.setState({ isDatePickerFocused: false });
        }
    };

    handleDateChange = (selectedDate: Date | undefined) => {
        if (selectedDate) {
            const date = turnDateToSimpleTime(selectedDate);
            this.props.setCurrentTradingDay(date);
            this.setState({ isDatePickerFocused: false }); // Close picker on select
        } else {
            const date = turnDateToSimpleTime(new Date(Date.now()));
            this.props.setCurrentTradingDay(date);
        }
    };

    render() {
        const selectedDate = new Date(this.props.currentTradingDay);
        const formattedDate = selectedDate.toLocaleDateString('en-GB');
        return (
            <div id='DatePicker' ref={this.pickerRef}>
                <h5>Date:</h5>
                <div className='DatePickerContainer'>
                    {!this.state.isDatePickerFocused && (
                    <span className="SelectedDate">{formattedDate}</span>
                    )}
                    {this.state.isDatePickerFocused && (
                        <DayPicker
                            mode="single"
                            selected={selectedDate}
                            onSelect={this.handleDateChange}
                            disabled={[
                                (date: Date) => [0, 6].includes(date.getDay()), // Disable weekends
                                { after: new Date() } // Disable future dates
                            ]}
                        />
                    )}
                    <FontAwesomeIcon
                        icon={faCalendarDay}
                        className='CalendarIcon'
                        onClick={() =>
                            this.setState((prevState) => ({
                                isDatePickerFocused: !prevState.isDatePickerFocused,
                            }))
                        }
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps({ dashboardReducer, loginReducer }: RootState) {
    const { currentTradingDay } = dashboardReducer;
    const { loginUserName } = loginReducer;
    return {
        currentTradingDay,
        loginUserName
    }
}

const connector = connect(mapStateToProps, { setCurrentTradingDay });
export default connector(DatePicker);